import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from './locales/lang-fr'
import en from './locales/lang-en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: process.env.VUE_APP_LOCALE,
  messages: {
    fr,
    en
  }
})

export default i18n
